import React from 'react';
import { Helmet } from 'react-helmet-async';
import WatchlistsManager from '../components/WatchlistsManager';

export default function WatchlistsPage() {
  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: '0 auto' }}>
      <Helmet><title>Watchlists — Algovex</title></Helmet>
      <WatchlistsManager />
    </div>
  );
}
